import { useState } from 'react';
import google from '../../styles/img/google.svg';
import eye from '../../styles/lottie/eye.json';
import eyeOff from '../../styles/lottie/eye-off.json';
import mailSvg from '../../styles/img/mail.svg';
import promo5euro from '../../styles/img/promo/inscription.svg';
import PrimaryButton from '../button/PrimaryButton';
import HandleGoogle from '../../pages/auth/login/HandleGoogle';
import { handleLogin } from '../../utils/LoginService';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useAxios from '../../axios/useAxios';
import { Popin } from '../popin/Popin';
import pikkoLogoBlob from '../../styles/img/promo/pikkoLogoBlob.svg';
import AccountCreation from '../../pages/auth/register/AccountCreation';
import Lottie from 'lottie-react';
import fid_card from '../../styles/img/fid_card.svg';

const LoginPopup = ({
  onClose,
  user,
  auth,
  fidCardId,
  email,
  setEmail,
  password,
  setPassword,
  isRegistration,
  setIsRegistration,
  hasFidelityCard,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const axiosInstance = useAxios();
  const { cartItems } = useSelector((state) => state.cart);
  const [showPassword, setShowPassword] = useState(false);
  const [isAccountCreationLoading, setIsAccountCreationLoading] =
    useState(false);
  const handleTogglePasswordVisibility = () => setShowPassword(!showPassword);

  const [mailInvisible, setMailInvisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogle = async () => {
    if (localStorage.getItem('newuser')) {
      localStorage.removeItem('newuser');
    }
    try {
      await HandleGoogle(auth, user);
    } catch (e) {
      console.error('Une erreur s\'est produite', e);
      alert('Une erreur s\'est produite');
    }
  };

  const handleBasicAuth = () => {
    handleLogin(
      setIsLoading,
      email,
      password,
      user,
      cartItems,
      axiosInstance,
      dispatch,
      navigate,
      fidCardId,
    );
  };

  return (
    <Popin className="signin-popup" onClose={onClose}>
      <div
        className={`bg-gradient1 contenaire_popup_inscription_top ${
          !mailInvisible ? ' row_top' : 'mailvisible_box'
        }`}
      >
        <img
          className="img_promo5_and_piece "
          src={isRegistration ? promo5euro : pikkoLogoBlob}
          alt=""
        />
        <div className="popin_header_text ">
          <div
            className={`30 text-4xl max-w-[250px]${
              !mailInvisible ? '' : ' text-left'
            }`}
            style={{ fontFamily: 'geomanistmedium' }}
          >
            {isRegistration ? (
              'Offre de bienvenue !'
            ) : (
              <div className="flex flex-col">
                <span className="big_text">Hey, </span> Ravi de te revoir !
              </div>
            )}{' '}
          </div>
          {!mailInvisible && (
            <div
              className="w-[100%] text-[14px] pb-4"
              style={{ fontFamily: 'Open Sans' }}
            >
              Et accède à de nombreux avantages
            </div>
          )}
        </div>
      </div>
      <div
        className={`${
          !mailInvisible && 'no-scroll'
        } scroll-contenaire-popup-login`}
      >
        <div className={`methode_group ${mailInvisible ? 'borderbottom' : ''}`}>
          <button
            onClick={() => setMailInvisible(!mailInvisible)}
            className="border-none"
          >
            <img src={!mailInvisible ? mailSvg : fid_card} alt="mail" />
          </button>
          <div className="flex items-center justify-center gap-4 text-3xl font-black flex-nowrap ">
            Ou
          </div>
          <button onClick={handleGoogle} className="border-none">
            <img src={google} alt="google" />
          </button>
        </div>
        <div
          className={
            !mailInvisible
              ? 'w-full contenaireinput_p transition-all  max-h-[0px] '
              : 'w-full transition-all  contenaireInput_mailvisible  max-h-[600px]'
          }
        >
          {isRegistration ? (
            <AccountCreation
              email={email}
              setEmail={setEmail}
              showPassword={showPassword}
              handleTogglePasswordVisibility={handleTogglePasswordVisibility}
              password1={password}
              setPassword1={setPassword}
              createAccountLoading={isAccountCreationLoading}
              setCreateaccountLoading={setIsAccountCreationLoading}
              user={user}
              onblurScrolltoTop={() => {}}
            />
          ) : (
            <>
              <div className="flex flex-col items-start w-full gap-4 inputGroup">
                <label htmlFor="email" className="promo_label geomanistBold">
                  Email
                </label>
                <input
                  className="w-full user_mail_input"
                  type="email"
                  id="email"
                  placeholder="Entre ton email"
                  name="email"
                  defaultValue={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="flex flex-col items-start w-full gap-4 inputGroup">
                <label
                  htmlFor="passwordCreate"
                  className="promo_label geomanistBold"
                >
                  Mot de passe
                </label>
                <input
                  className="w-full mb-6 user_mail_input"
                  defaultValue={password}
                  type={showPassword ? 'text' : 'password'}
                  id="passwordCreate"
                  placeholder="Entre ton mot de passe"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  className="absolute top-[58%] right-8 transform -translate-y-1/2"
                  onClick={handleTogglePasswordVisibility}
                >
                  {showPassword ? (
                    <Lottie
                      animationData={eye}
                      loop={false}
                      autoplay={true}
                      style={{ width: '20px', height: '20px' }} // Adjust the width and height as needed
                    />
                  ) : (
                    <Lottie
                      animationData={eyeOff}
                      loop={false}
                      autoplay={true}
                      style={{ width: '20px', height: '20px' }} // Adjust the width and height as needed
                    />
                  )}
                </button>
              </div>
              <PrimaryButton
                onClick={handleBasicAuth}
                label={"C'est parti"}
                isLoading={isLoading}
              />
            </>
          )}
          {!hasFidelityCard &&
            (isRegistration ? (
              <div className={`question_popins`}>
                Déjà un compte ?{' '}
                <span
                  onClick={() => setIsRegistration(false)}
                  className="cursor-pointer"
                >
                  Je me connecte
                </span>
              </div>
            ) : (
              <div className={`question_popins`}>
                Pas encore de compte ?{' '}
                <span
                  onClick={() => setIsRegistration(true)}
                  className="cursor-pointer"
                >
                  Je m'inscris
                </span>
              </div>
            ))}
        </div>
      </div>
    </Popin>
  );
};

export default LoginPopup;
